/* WOKORA v2.6 — header host support. Sticky scroll state is owned by wokora-v11.js. */
(() => {
  'use strict';

  const setup = () => {
    const header = document.querySelector('.wk-hdr[data-site-header]');
    if (!header || header.dataset.wkHeaderReady === 'true') return;
    header.dataset.wkHeaderReady = 'true';

    if (header.dataset.sticky === 'true') {
      const host = header.closest('.shopify-section') || header.parentElement;
      if (host && host !== document.body) host.classList.add('wk-hdr-sticky-host');
    }
  };

  setup();
  document.addEventListener('shopify:section:load', setup);
})();
